import { AuthQuestionType } from '@/shared/types/node';

interface QuestionTemplate {
  labelKey: string;
  shortLabelKey: string;
  defaultSaveAs: string;
  type: AuthQuestionType;
}

interface TemplateCategory {
  labelKey: string;
  templates: QuestionTemplate[];
}

export const questionTemplates: TemplateCategory[] = [
  {
    labelKey: 'dialog.auth.template_category_primary',
    templates: [
      {
        labelKey: 'dialog.auth.template_full_legal_name',
        shortLabelKey: 'dialog.auth.template_short_full_legal_name',
        defaultSaveAs: 'full_legal_name',
        type: 'text',
      },
      {
        labelKey: 'dialog.auth.template_date_of_birth',
        shortLabelKey: 'dialog.auth.template_short_date_of_birth',
        defaultSaveAs: 'dob',
        type: 'date',
      },
      {
        labelKey: 'dialog.auth.template_social_security_number',
        shortLabelKey: 'dialog.auth.template_short_social_security_number',
        defaultSaveAs: 'ssn',
        type: 'alphanumeric',
      },
    ],
  },
  {
    labelKey: 'dialog.auth.template_category_contact',
    templates: [
      {
        labelKey: 'dialog.auth.template_current_address',
        shortLabelKey: 'dialog.auth.template_short_current_address',
        defaultSaveAs: 'current_address',
        type: 'text',
      },
      {
        labelKey: 'dialog.auth.template_registered_phone',
        shortLabelKey: 'dialog.auth.template_short_registered_phone',
        defaultSaveAs: 'registered_phone',
        type: 'phone',
      },
      {
        labelKey: 'dialog.auth.template_registered_email',
        shortLabelKey: 'dialog.auth.template_short_registered_email',
        defaultSaveAs: 'registered_email',
        type: 'email',
      },
      {
        labelKey: 'dialog.auth.template_previous_address',
        shortLabelKey: 'dialog.auth.template_short_previous_address',
        defaultSaveAs: 'previous_address',
        type: 'text',
      },
    ],
  },
  {
    labelKey: 'dialog.auth.template_category_account',
    templates: [
      {
        labelKey: 'dialog.auth.template_last_4_digits',
        shortLabelKey: 'dialog.auth.template_short_last_4_digits',
        defaultSaveAs: 'last_4_digits',
        type: 'alphanumeric',
      },
      {
        labelKey: 'dialog.auth.template_recent_transaction',
        shortLabelKey: 'dialog.auth.template_short_recent_transaction',
        defaultSaveAs: 'recent_transaction',
        type: 'number',
      },
      {
        labelKey: 'dialog.auth.template_account_opening_date',
        shortLabelKey: 'dialog.auth.template_short_account_opening_date',
        defaultSaveAs: 'account_opening_date',
        type: 'date',
      },
    ],
  },
];

export type { QuestionTemplate, TemplateCategory };
